import { Injectable } from '@angular/core';
import { BaseService } from '@core/service/base.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PurOrderToAskGoodsService extends BaseService{

  constructor(http:HttpClient) {
    super(http)
  }

  getUrl(): string {
    return "api/purOrderDetail";
  }
}
